import { pro_name, hostUrl, gxHostUrl, authorizationUrl, wechat_id, appid, isYzgx, npm_env} from './env'
import { wxConfigData, setErrorLog, wxConfigDataById, setShareLog, wxAuth } from './../service/getData'
// import router from '../router/index';
import Vue from 'vue'
import Mint, {Toast} from 'mint-ui'
import md5 from 'js-md5';
import {Login, Newlogin, App, Tools } from 'youshumethod'
import { xlogService, xlogMessage } from '@youshu/mono-sdk'
import sensors from 'sa-sdk-javascript';
Vue.use(Mint);

let IOS_WX_SIGNATURE_URL = ''   // reffer授权
let IOS_WX_SIGNATURE_URL_ID = ''    // 通过ID授权

/**
 * 统计数据
 */
export const cnzzCount = (data) => {
    var cnzzid = data ? data : 1260093070;
    if (!document.getElementById("cnzzhead")) {
        var countHeadCode = document.createElement("script");
        countHeadCode.setAttribute("id", "cnzzhead");
        countHeadCode.appendChild(document.createTextNode("var _czc = _czc || [];_czc.push(['_setAccount', " + cnzzid + "])"))
        document.getElementsByTagName("head")[0].insertBefore(countHeadCode, document.getElementsByTagName("head").childNodes)

        var countFootCode = document.createElement("script");
        countFootCode.src = "https://s4.cnzz.com/z_stat.php?id=" + cnzzid + "&web_id=" + cnzzid;
        document.getElementsByTagName("body")[0].insertBefore(countFootCode, document.getElementsByTagName("body").childNodes)
    }
}

/**
 * 统计事件(神策)
 */

export const sensorsEvent = (options) => {
    try{
        // 点击事件
        options.eventName = options.eventName ? options.eventName : 'vKNoPageClick';
        options.eventObject = options.eventObject != null ? options.eventObject : {};
        // 属性字段类型过滤
        options.eventObject.plan_id = options.eventObject.plan_id != undefined ? options.eventObject.plan_id.toString() : undefined;
        options.eventObject.pb_id = options.eventObject.pb_id != undefined ? options.eventObject.pb_id.toString() : undefined;
        options.eventObject.pack_id = options.eventObject.pack_id != undefined ? options.eventObject.pack_id.toString() : undefined;
        options.eventObject.plan_stage = options.eventObject.plan_stage != undefined ? parseInt(options.eventObject.plan_stage) : undefined;
        options.eventObject.exam_id = options.eventObject.exam_id != undefined ? options.eventObject.exam_id.toString() : undefined;
        options.eventObject.task_id = options.eventObject.task_id != undefined ? options.eventObject.task_id.toString() : undefined;
        options.eventObject.act_id = options.eventObject.act_id != undefined ? options.eventObject.act_id.toString() : undefined;
        options.eventObject.item_value = options.eventObject.item_value != undefined ? options.eventObject.item_value.toString() : undefined;
        options.eventObject.business_id = options.eventObject.business_id != undefined ? parseInt(options.eventObject.business_id) : undefined;
        options.eventObject.collection_id = options.eventObject.collection_id != undefined ? options.eventObject.collection_id.toString() : undefined;
        options.eventObject.chapter_id = options.eventObject.chapter_id != undefined ? options.eventObject.chapter_id.toString() : undefined;
        options.eventObject.page_name = options.eventObject.page_name != undefined ? options.eventObject.page_name.toString() : undefined;
        // console.log(md5(document.location.hash.split('#/')[1] + '_' + new Date().getTime()));
        sensors.track(options.eventName, options.eventObject);
    }
    catch(err){
        console.error("未开启统计", err)
    }
}


/**
 * 统计事件
 */
export const cnzzEvent = (options) => {
    try {
        _czc.push(['_trackEvent', options.category, options.action, options.label, options.value]);
    } catch (err) {
        console.error("未开启统计")
    }
}


/**
 * 统计事件(带维度)
 * @param options.bussiness_type 商品类型 (sound_book,audio_book,plan)
 * @param options.bussiness_id   商品ID   (plan_id,theme_book_list_id)
 * @param options.collection_id  书籍ID   (pb_id,audio_book_id)
 * @param options.chapter_id     文稿ID   (pack_id,chapter_id)
 * @param options.category       事件类别  (页面标识)
 * @param options.action         事件操作  (播放，暂停，持续时间，添加播放列表，下载，单击...)
 * @param options.label          事件名称  (执行动作名称)
 * @param options.value          可选数值  (阅读时长等)
 */

/**
 * 微信配置
 */

export const wxConfig = (options) => {
    if (IOS_WX_SIGNATURE_URL == '' && versions() == 'ios') {
        IOS_WX_SIGNATURE_URL = window.location.href.split(/#/)[0];
        window.IOS_WX_SIGNATURE_URL = IOS_WX_SIGNATURE_URL;
    }
    wxConfigData(IOS_WX_SIGNATURE_URL).then(res => {
        if (res.code == 1) {
            wx.config({
                debug: (Tools.cookie.get('HTTP_X_YS_UID') == 7363629 || Tools.cookie.get('HTTP_X_YS_UID') == 29963698) ? true : options.debug,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
              openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp'],
              jsApiList: options.jsApiList,
            });
            if (options.ShareTitle && options.ShareLink && options.ShareImgUrl) {
                var wxShare = {
                    title: options.ShareTitle,
                    desc: options.ShareDesc,
                    link: options.ShareLink,
                    imgUrl: options.ShareImgUrl,
                    success: function() { options.ShareSuccess && options.ShareSuccess() },
                    cancel: function() { options.ShareCancel && options.ShareCancel() }
                }
                wx.ready(function() {
                    wx.onMenuShareTimeline(wxShare);
                    wx.onMenuShareAppMessage(wxShare);
                })
            }
            wx.error(function(json) {
                xlogService('INFO', 'WECHAT_CONFIG', {
                    "debug": options.debug,
                    ...res.data,
                    "jsApiList": options.jsApiList
                }, {
                    code: json.errCode || 0,
                    msg: JSON.stringify(json)
                }, json.errMsg || '')
            });
        } else {
            Vue.$toast(res.msg)
        }
    })
}

/**
 * 微信配置功能
 * 1、统一服务，微信端页面初始化完成需要调取（判断环境为微信）
 * 2、功能：为了实现微信端页面分享出去和打卡的日志记录，需要配置和未配置分享的页面有统一utm参数。
 * 3、需配置参数
 * pro_name ：项目全局参数，可定义到env文件中
 * type : share（有分享配置） or hide（隐藏分享） or default（默认分享）
 * wechat_id：微信ID
 * debug:是否开启debug true or false
 * campaign : utm_campaign 值 为页面主要参数 （例如：liebian_plan:330:1662:26584）
 * ShareTitle '分享标题'
 * ShareDesc '分享描述'
 * ShareImgUrl '分享图片'
 * ShareLink '分享链接'
 *
 */


export const wechatConfig = (options) => {
    let jsApiList = [
        'updateAppMessageShareData', 'updateTimelineShareData', 'openAddress', 'checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem',
        'translateVoice', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'onVoicePlayEnd', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice',
        'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay',

      ],
      wxShare = {};
    let referer =  options.referer || window.location.href;
    wxConfigDataById(options.wechat_id || wechat_id, referer).then(res => {
        if (res.code == 1) {
            // 配置参数
            wx.config({
                debug: (Tools.cookie.get('HTTP_X_YS_UID') == 7363629 || Tools.cookie.get('HTTP_X_YS_UID') == 29963698) ? true : options.debug,
                // debug: true,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: jsApiList,
              openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp'],
            });
            // 记录错误日志
            wx.error(function(json) {
                xlogService('INFO', 'WECHAT_CONFIG', {
                    "debug": options.debug,
                    ...res.data,
                    "jsApiList": options.jsApiList,
                    "wechat_id": options.wechat_id || wechat_id
                }, {
                    code: json.errCode || 0,
                    msg: JSON.stringify(json)
                }, json.errMsg || '')
            });

            let goods_id = isYzgx ? '149500' : '129500'
            let url = authorizationUrl + "/p/tradepage_h5/page_goods?goods_id=" + goods_id + "&goods_type=membership";
            // 配置分享
            if (options.type == 'share') {
                // 有分享配置参数
                url = options.ShareLink ? options.ShareLink : url;
                wxShare = {
                    title: options.ShareTitle || (isYzgx ? '元知国学会员' : '有趣有用  元知课堂'),
                    desc: options.ShareDesc || (isYzgx ? '传承国学经典，弘扬传统文化' : '世界上只有一种稳赚不赔的投资，就是学习'),
                    link: (options.ShareLink + (url.indexOf('?') != -1 ? '&' : '?') + getUtmStr(options)) || url,
                    imgUrl: options.ShareImgUrl || 'https://feed.youshu.cc/readwith/media/picture/64c0ed95dbe77.jpeg',
                }
            } else if (options.type == 'default') {
                // 默认分享配置参数
                // let url = options.ShareLink ? options.ShareLink : filterUrlUtm(location.href);
                url = options.ShareLink ? options.ShareLink : url;
                wxShare = {
                    title: isYzgx ? '元知国学会员' : '元知课堂打卡会员',
                    desc: isYzgx ? '传承国学经典，弘扬传统文化' : '元知课堂打卡会员',
                    link: url + (url.indexOf('?') != -1 ? '&' : '?') + getUtmStr(options),
                    imgUrl: 'https://feed.youshu.cc/readwith/media/picture/64c0ed95dbe77.jpeg',
                }
            } else if (options.type == 'hide') {
                // 隐藏分享
                wx.ready(function() {
                    console.log('ready成功!hide')
                    wx.hideOptionMenu();
                })
                return
            }

            // 分享成功回调
            wxShare.success = function() {
                if (getCookie('HTTP_X_YS_UID') != '' && getCookie('HTTP_X_YS_USER_TOKEN') != '' && getCookie('HTTP_X_YS_UID') > 0) {
                    setShareLog(wxShare.link, pro_name, location.href, '').then(res => {
                        if (res.code == 1) {
                            console.log('分享日志记录成功!')
                        } else {
                            Vue.$toast(res.msg)
                        }
                    })
                    options.ShareSuccess && options.ShareSuccess()
                }
            }

            // 分享失败回调
            wxShare.cancel = function() {
                options.ShareCancel && options.ShareCancel()
            }

            // 分享配置
            wx.ready(function() {
                console.log('ready成功!config', wxShare)
                wx.updateAppMessageShareData(wxShare);
                wx.updateTimelineShareData(wxShare);
            })

        } else {
            Vue.$toast(res.msg)
        }
    })
}

export const getUtmStr = (options) => {
    let str = `utm_source=${pro_name}&utm_medium=${options.utm_medium ? options.utm_medium : ''}&utm_campaign=${options.utm_campaign ? options.utm_campaign : ''}&utm_term=` + getUtmTerm()
    return str
}

export const filterUrlUtm = (url_path) => {
    if (!url_path) {
        return
    }
    // 截取当前url，存在plan_id参数，默认分享链接添加tag_type=plan
    if (url_path.split('plan_id=').length > 1) {
        url_path = url_path + '&tag_type=plan'
    }
    let utm_data = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'];
    let url_utm_data;
    // 将url上参数截取为数组
    if (url_path.split('?').length > 1) {
        // 将url上参数截取为数组
        url_utm_data = [url_path.split('?')[0]];
        if (url_path.split('?')[1].split('&').length != -1) {
            url_utm_data = url_utm_data.concat(url_path.split('?')[1].split('&'));
        }

        // 过滤utm参数
        for (let i in utm_data) {
            for (let len = url_utm_data.length, j = len - 1; j >= 0; j--) {
                if (url_utm_data[j].split(utm_data[i]).length > 1) {
                    url_utm_data.splice(j, 1);
                    break;
                }
            }
        }

        // 重新组装url地址
        url_path = '';
        url_utm_data.map((item, index) => {
            url_path = url_path + (index == 0 ? '' : (index == 1 ? '?' : '&')) + item;
        })
        return url_path;
    } else {
        return url_path;
    }
}


/**
 * 获取utm_term
 * 优先级取cookie中 HTTP_X_YS_UID 值，如果 HTTP_X_YS_UID 不存在，获取ys_wx_auth_id值
 * 值为 uid_ + 用户ID 或者 wx_ + ys_wx_auth_id值
 */
export const getUtmTerm = () => {
    let utmTerm = '';
    if (getCookie('HTTP_X_YS_UID')) {
        utmTerm = 'uid_' + getCookie('HTTP_X_YS_UID');
    } else if (getCookie('ys_wx_auth_id')) {
        utmTerm = 'wx_' + getCookie('ys_wx_auth_id');
    }
    return utmTerm;
}

/**
 * 上传图片类型检测
 */
export const checkUploadImages = (file, num) => {
    //alert("file="+file.length)
    //alert(JSON.stringify(file))
    if (!file.length) return 0;
    if (file.length > 9) return 10;
    if ((file.length + num) > 9) return 101;
    for (var i = 0; i < file.length; i++) {
        return 1
        // switch(file[i].path.split('\\')[file[i].path.split('\\').length-1].split(".")[1]){
        //     case "jpg":
        //         alert("1")
        //         return 1
        //     break;
        //     case "gif":
        //         alert("1")
        //         return 1
        //     break;
        //     case "png":
        //         alert("1")
        //         return 1
        //     break;
        //     case "jpeg":
        //         alert("1")
        //         return 1
        //     break;
        //     case "bmp":
        //         alert("1")
        //         return 1
        //     break;
        //     default:
        //         alert("11")
        //         return 11
        //     break;
        // }
    }
}

/**
 * 图片转Base64
 */
export const convertImgToBase64 = (url, callback, outputFormat) => {
    var canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'),
        img = new Image;
    img.crossOrigin = 'Anonymous';
    img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || 'image/png');
        callback.call(this, dataURL);
        canvas = null;
    };
    img.crossOrigin = '';
    img.src = url;
}


/**
 * html2canvas
 * 需要图片转为base64后调用
 */
export const html2images = (app, id, success) => {
    var node = document.getElementById(id),
        canvascard = document.createElement("canvas");
    canvascard.setAttribute("id", "canvascard");
    canvascard.setAttribute("style", "position: fixed;top:0");
    node.appendChild(canvascard)
    html2canvas(node, {
        canvas: createHiDPICanvas(2, id, "canvascard"),
        onrendered: function(canvas) {
            var dataUrl = canvas.toDataURL("image/png");
            var img = new Image();
            img.src = dataUrl;
            img.style.width = "100%";
            node.style.display = "none";
            document.getElementById("canvascard").style.display = "none";
            document.getElementById(app).style.display = 'block'
            let childList = document.getElementById(app).childNodes;
            if (childList.length > 0) {
                for (let j = 0; j < childList.length; j++) {
                    document.getElementById(app).removeChild(childList[j])
                }
            }
            document.getElementById(app).appendChild(img);
            success(dataUrl);
        }
    })

    function PIXEL_RATIO(card) {
        var ctx = document.getElementById(card).getContext("2d"),
            dpr = window.devicePixelRatio || 1,
            bsr = ctx.webkitBackingStorePixelRatio ||
                ctx.mozBackingStorePixelRatio ||
                ctx.msBackingStorePixelRatio ||
                ctx.oBackingStorePixelRatio ||
                ctx.backingStorePixelRatio || 1;

        return dpr / bsr;
    }

    function createHiDPICanvas(ratio, id, card) {
        if (!ratio) { ratio = PIXEL_RATIO(card); }
        var can = document.getElementById(card);
        var w = document.getElementById(id).offsetWidth,
            h = document.getElementById(id).offsetHeight;
        can.width = w * ratio;
        can.height = h * ratio;
        can.style.width = w + "px";
        can.style.height = h + "px";
        can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
        return can;
    }
}

/**
 * html2canvas
 * 自动获取dome中img，转换为base64后画图
 */
export const html2imagesBase64 = (app, id, success) => {

    var node = document.getElementById(id),
        canvascard = document.createElement("canvas"),
        imgGroup = node.getElementsByTagName('img'),
        flag = 0,
        img = [],
        i = 0,
        start = false;

    // html中的图片转base64
    imgsToBase64();

    // html中的图片不是base64的转为base64
    function imgsToBase64() {
        if (imgGroup[i].src.indexOf('data:image') === -1) {
            //path 图片src转换为base64
            convertImgToBase64(imgGroup[i].src, function(base64Img) {
                imgGroup[i].src = base64Img;
                if (i < imgGroup.length - 1) {
                    i++;
                    imgsToBase64();
                }
            });
        } else if (i < imgGroup.length - 1) {
            i++;
        }

        var loadTimer = setInterval(function() {
            // 所有图片加载完毕
            if (i == imgGroup.length - 1) {
                if (flag >= imgGroup.length) {
                    starthtml2canvas();
                    clearInterval(loadTimer);
                    return;
                }
                // 根据指定要加载的图片 的KEY 加载图片的方法
                loadImg(flag);

                function loadImg(imgKey) {
                    var curImg = imgGroup[imgKey].src;
                    var loadImg = new Image();
                    loadImg.src = curImg;
                    loadImg.onload = function() {
                        //单张 指定要加载的图片 加载完成后，设置KEY + 1，并设置是否加载成功的变量为true
                        flag++;
                    }
                }
            }
        }, 100);

    }

    function starthtml2canvas() {
        if (!start) {
            start = true;
            canvascard.setAttribute("id", "canvascard");
            canvascard.setAttribute("style", "position: fixed;top:0");
            node.appendChild(canvascard);
            html2canvas(node, {
                canvas: createHiDPICanvas(2, id, "canvascard"),
                onrendered: function(canvas) {
                    var dataUrl = canvas.toDataURL("image/png");
                    var img = new Image();
                    img.src = dataUrl;
                    img.style.width = "100%";
                    node.style.display = "none";
                    document.getElementById("canvascard").style.display = "none";
                    document.getElementById(app).style.display = 'block'
                    let childList = document.getElementById(app).childNodes;
                    if (childList.length > 0) {
                        for (let j = 0; j < childList.length; j++) {
                            document.getElementById(app).removeChild(childList[j])
                        }
                    }
                    document.getElementById(app).appendChild(img);
                    start = false;
                    success(dataUrl);
                }
            })
        }

    }

    function PIXEL_RATIO(card) {
        var ctx = document.getElementById(card).getContext("2d"),
            dpr = window.devicePixelRatio || 1,
            bsr = ctx.webkitBackingStorePixelRatio ||
                ctx.mozBackingStorePixelRatio ||
                ctx.msBackingStorePixelRatio ||
                ctx.oBackingStorePixelRatio ||
                ctx.backingStorePixelRatio || 1;

        return dpr / bsr;
    }

    function createHiDPICanvas(ratio, id, card) {
        if (!ratio) { ratio = PIXEL_RATIO(card); }
        var can = document.getElementById(card);
        var w = document.getElementById(id).offsetWidth ? document.getElementById(id).offsetWidth : '',
            h = document.getElementById(id).offsetHeight ? document.getElementById(id).offsetHeight : '';
        can.width = w * ratio;
        can.height = h * ratio;
        can.style.width = w + "px";
        can.style.height = h + "px";
        can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
        return can;
    }
}

/**
 *
 * 转换成阿里云图片数据
 */

export const makeImgData = (imgData) => {

    var posterData = [];
    if (imgData.avatar.show) {
        posterData.push({
            type: 'image',
            url: imgData.avatar.url.indexOf('://avatar.youshu.cc/') >= 0 ? imgData.avatar.url.split('://avatar.youshu.cc/')[1] : imgData.avatar.url.replace("http://avatar.youshu.cc/", ""),
            r: Number(imgData.avatar.width) / 2, //内切圆，r为图片半径
            t: 100, //透明度，取值范围: [0-100]  100不透明
            g: 'nw', //位置 nw, north, ne, west, center, east, sw, south, se
            w: imgData.avatar.width, //素材图片宽
            h: imgData.avatar.width, //素材图片高 
            y: imgData.avatar.top, //水平边距
            x: imgData.avatar.left, //垂直边距
        })
    }
    if (imgData.nickname.show) {
        posterData.push({
            type: 'text', //绘制类型
            text: imgData.nickname.name,
            size: imgData.nickname.fontSize, //文字水印文字大小(px)  取值范围：(0，1000]
            color: imgData.nickname.color.replace('#', ''), //文字水印文字的颜色
            t: 100, //透明度，取值范围: [0-100]  100不透明
            g: 'nw', //位置 nw, north, ne, west, center, east, sw, south, se
            y: imgData.nickname.top, //水平边距
            x: imgData.nickname.left, //垂直边距
        })
    }
    if (imgData.titleDataShow && imgData.titleData.length > 0) {
        for (let i in imgData.titleData) {
            posterData.push({
                type: 'text', //绘制类型
                text: imgData.titleData[i].content ? imgData.titleData[i].content : 'null',
                size: imgData.titleData[i].fontSize, //文字水印文字大小(px)  取值范围：(0，1000]
                color: imgData.titleData[i].color.replace('#', ''), //文字水印文字的颜色
                t: 100, //透明度，取值范围: [0-100]  100不透明
                g: 'nw', //位置 nw, north, ne, west, center, east, sw, south, se
                y: imgData.titleData[i].top, //水平边距
                x: imgData.titleData[i].left, //垂直边距
            })
        }
    }
    if (imgData.wordTitle.show) {
        posterData.push({
            type: 'text', //绘制类型
            text: getStrLen(imgData.wordTitle.content) > 40 ? cutstr(imgData.wordTitle.content, 40) : imgData.wordTitle.content,
            size: imgData.wordTitle.fontSize, //文字水印文字大小(px)  取值范围：(0，1000]
            color: imgData.wordTitle.color.replace('#', ''), //文字水印文字的颜色
            t: 100, //透明度，取值范围: [0-100]  100不透明
            g: 'nw', //位置 nw, north, ne, west, center, east, sw, south, se
            y: imgData.wordTitle.top, //水平边距
            x: imgData.wordTitle.left, //垂直边距
        })
    }
    if (imgData.qrcode.show) {
        posterData.push({
            type: 'image',
            url: imgData.qrcode.url.indexOf('://avatar.youshu.cc/') >= 0 ? imgData.qrcode.url.split('://avatar.youshu.cc/')[1] : imgData.qrcode.url.replace("http://avatar.youshu.cc/", ""),
            t: 100, //透明度，取值范围: [0-100]  100不透明
            g: 'nw', //位置 nw, north, ne, west, center, east, sw, south, se
            w: imgData.qrcode.width, //素材图片宽
            h: imgData.qrcode.width, //素材图片高
            y: imgData.qrcode.top, //水平边距
            x: imgData.qrcode.left, //垂直边距
        })
    }
    let imgJson = {
        url: imgData.bg_img, //绘制背景底图
        w: 750, //设置图片宽
        h: 1260, //设置图片高
        data: posterData
    }
    return makeImg(imgJson)
}

/**
 *
 * 阿里云生成图片
 */
export const makeImg = (json) => {
    var img = json.url + '?x-oss-process=image/quality,Q_100/resize,w_' + json.w + ',h_' + json.h;
    for (var i = 0; i < json.data.length; i++) {
        if (json.data[i].type == 'text') {
            img = img + '/watermark,type_ZmFuZ3poZW5naGVpdGk=,size_' + json.data[i].size + ',text_' + base64_encode(utf16to8(json.data[i].text)) + ',color_' + json.data[i].color + ',t_' + json.data[i].t + ',g_' + json.data[i].g + ',x_' + json.data[i].x + ',y_' + json.data[i].y;
        } else if (json.data[i].type == 'image') {
            console.log(json.data[i].url)

            if (json.data[i].r) {
                json.data[i].url = json.data[i].url + '?x-oss-process=image/resize,m_fixed,w_' + json.data[i].w + ',h_' + json.data[i].h + '/circle,r_' + json.data[i].r;

            } else {
                json.data[i].url = json.data[i].url + '?x-oss-process=image/resize,m_fixed,w_' + json.data[i].w + ',h_' + json.data[i].h;
            }
            img = img + '/watermark,image_' + base64_encode(json.data[i].url) + ',t_' + json.data[i].t + ',g_' + json.data[i].g + ',x_' + json.data[i].x + ',y_' + json.data[i].y;
        }
    }
    return img;
}

/**
 * 获取字符串长度（字符）
 */
export const getStrLen = (str) => {
    if (str == null) return 0;
    if (typeof str != "string") {
        str += "";
    }
    return str.replace(/[^\x00-\xff]/g, "01").length;
}

/**
 * 判断字符串长度是否大于设定字符数量
 * 返回限定字符串长度
 */
export const cutstr = (str, len) => {
    var str_length = 0,
        str_len = 0,
        str_cut = new String(),
        str_len = str.length;
    for (var i = 0; i < str_len; i++) {
        let a = str.charAt(i);
        str_length++;
        if (escape(a).length > 4) {
            //中文字符的长度经编码之后大于4
            str_length++;
        }
        str_cut = str_cut.concat(a);
        if (str_length >= len) {
            str_cut = str_cut.concat("...");
            return str_cut;
        }
    }
    //如果给定字符串小于指定长度，则返回源字符串；
    if (str_length < len) {
        return str;
    }
}

/**
 *
 * base64
 */
export const base64_encode = (str) => {
    // console.log(str)
    var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
        52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
        15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
    var out, i, len;
    var c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt((c1 & 0x3) << 4);
            out += "==";
            break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            out += base64EncodeChars.charAt((c2 & 0xF) << 2);
            out += "=";
            break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3F);
    }
    out = out.replace(/\+/g, "-")
    out = out.replace(/\//g, "_")
    return out;
}


export const utf16to8 = (str) => {
    var out, i, len, c;

    out = "";
    len = str.length;
    for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if ((c >= 0x0001) && (c <= 0x007F)) {
            out += str.charAt(i);
        } else if (c > 0x07FF) {
            out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        } else {
            out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        }
    }
    return out;
}

/**
 * 删除Cookies数据
 */
export const delCookie = (name) => {
    let exp = new Date();
    exp.setTime(exp.getTime() + (-1 * 24 * 60 * 60 * 1000));
    let cval = getCookie(name);
    if(cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()+ ";domain=" + "." + document.domain.split('.').slice(-2).join('.')  + ";path=/";
    }
}

/**
 * 获取Cookies数据
 */
export const getCookie = (c_name) => {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=")
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            let c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return decodeURIComponent(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}

/**
 * 设置Cookies数据
 */
export const setCookie = (name, value, time, domain, path) => {
    var str = name + "=" + value;
    if (time) {
        var date = new Date(time);
        str += ";expires=" + date;
    }
    str = domain ? (str + ";domain=" + domain) : (str + ";domain=" + "." + location.hostname.split('.')[1] + '.' + location.hostname.split('.')[2]);
    str = path ? (str + ';path=' + path) : (str + ';path=/');
    document.cookie = str;
}


/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取sessionStorage
 */
export const getSessionStorage = name => {
    if (!name) return;
    return window.sessionStorage.getItem(name);
}

/**
 * 存储sessionStorage
 */
export const setSessionStorage = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
    let target;
    // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
    if (attr === 'scrollTop') {
        target = element.scrollTop;
    } else if (element.currentStyle) {
        target = element.currentStyle[attr];
    } else {
        target = document.defaultView.getComputedStyle(element, null)[attr];
    }
    //在获取 opactiy 时需要获取小数 parseFloat
    return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
}

/**
 * 页面到达底部，加载更多
 */
export const loadMore = (element, callback) => {
    let windowHeight = window.screen.height;
    let height;
    let setTop;
    let paddingBottom;
    let marginBottom;
    let requestFram;
    let oldScrollTop;

    document.body.addEventListener('scroll', () => {
        loadMore();
    }, false)
    //运动开始时获取元素 高度 和 offseTop, pading, margin
    element.addEventListener('touchstart', () => {
        height = element.offsetHeight;
        setTop = element.offsetTop;
        paddingBottom = getStyle(element, 'paddingBottom');
        marginBottom = getStyle(element, 'marginBottom');
    }, { passive: true })

    //运动过程中保持监听 scrollTop 的值判断是否到达底部
    element.addEventListener('touchmove', () => {
        loadMore();
    }, { passive: true })

    //运动结束时判断是否有惯性运动，惯性运动结束判断是非到达底部
    element.addEventListener('touchend', () => {
        oldScrollTop = document.body.scrollTop;
        moveEnd();
    }, { passive: true })

    const moveEnd = () => {

        requestFram = requestAnimationFrame(() => {
            if (document.body.scrollTop != oldScrollTop) {
                oldScrollTop = document.body.scrollTop;
                loadMore();
                moveEnd();
            } else {
                cancelAnimationFrame(requestFram);
                //为了防止鼠标抬起时已经渲染好数据从而导致重获取数据，应该重新获取dom高度
                height = element.offsetHeight;
                loadMore();
            }
        })
    }

    const loadMore = () => {
        if (document.body.scrollTop + windowHeight >= height + setTop + paddingBottom + marginBottom) {
            callback();
        }
    }
}

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = callback => {
    let requestFram;
    let oldScrollTop;

    document.addEventListener('scroll', () => {
        showBackFun();
    }, false)
    document.addEventListener('touchstart', () => {
        showBackFun();
    }, { passive: true })

    document.addEventListener('touchmove', () => {
        showBackFun();
    }, { passive: true })

    document.addEventListener('touchend', () => {
        oldScrollTop = document.body.scrollTop;
        moveEnd();
    }, { passive: true })

    const moveEnd = () => {
        requestFram = requestAnimationFrame(() => {
            if (document.body.scrollTop != oldScrollTop) {
                oldScrollTop = document.body.scrollTop;
                moveEnd();
            } else {
                cancelAnimationFrame(requestFram);
            }
            showBackFun();
        })
    }

    //判断是否达到目标点
    const showBackFun = () => {
        if (document.body.scrollTop > 500) {
            callback(true);
        } else {
            callback(false);
        }
    }
}


/**
 * 运动效果
 * @param {HTMLElement} element   运动对象，必选
 * @param {JSON}        target    属性：目标值，必选
 * @param {number}      duration  运动时间，可选
 * @param {string}      mode      运动模式，可选
 * @param {function}    callback  可选，回调函数，链式动画
 */
export const animate = (element, target, duration = 400, mode = 'ease-out', callback) => {
    clearInterval(element.timer);

    //判断不同参数的情况
    if (duration instanceof Function) {
        callback = duration;
        duration = 400;
    } else if (duration instanceof String) {
        mode = duration;
        duration = 400;
    }

    //判断不同参数的情况
    if (mode instanceof Function) {
        callback = mode;
        mode = 'ease-out';
    }

    //获取dom样式
    const attrStyle = attr => {
        if (attr === "opacity") {
            return Math.round(getStyle(element, attr, 'float') * 100);
        } else {
            return getStyle(element, attr);
        }
    }
    //根字体大小，需要从此将 rem 改成 px 进行运算
    const rootSize = parseFloat(document.documentElement.style.fontSize);

    const unit = {};
    const initState = {};

    //获取目标属性单位和初始样式值
    Object.keys(target).forEach(attr => {
        if (/[^\d^\.]+/gi.test(target[attr])) {
            unit[attr] = target[attr].match(/[^\d^\.]+/gi)[0] || 'px';
        } else {
            unit[attr] = 'px';
        }
        initState[attr] = attrStyle(attr);
    });

    //去掉传入的后缀单位
    Object.keys(target).forEach(attr => {
        if (unit[attr] == 'rem') {
            target[attr] = Math.ceil(parseInt(target[attr]) * rootSize);
        } else {
            target[attr] = parseInt(target[attr]);
        }
    });


    let flag = true; //假设所有运动到达终点
    const remberSpeed = {}; //记录上一个速度值,在ease-in模式下需要用到
    element.timer = setInterval(() => {
        Object.keys(target).forEach(attr => {
            let iSpeed = 0; //步长
            let status = false; //是否仍需运动
            let iCurrent = attrStyle(attr) || 0; //当前元素属性址
            let speedBase = 0; //目标点需要减去的基础值，三种运动状态的值都不同
            let intervalTime; //将目标值分为多少步执行，数值越大，步长越小，运动时间越长
            switch (mode) {
                case 'ease-out':
                    speedBase = iCurrent;
                    intervalTime = duration * 5 / 400;
                    break;
                case 'linear':
                    speedBase = initState[attr];
                    intervalTime = duration * 20 / 400;
                    break;
                case 'ease-in':
                    let oldspeed = remberSpeed[attr] || 0;
                    iSpeed = oldspeed + (target[attr] - initState[attr]) / duration;
                    remberSpeed[attr] = iSpeed
                    break;
                default:
                    speedBase = iCurrent;
                    intervalTime = duration * 5 / 400;
            }
            if (mode !== 'ease-in') {
                iSpeed = (target[attr] - speedBase) / intervalTime;
                iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);
            }
            //判断是否达步长之内的误差距离，如果到达说明到达目标点
            switch (mode) {
                case 'ease-out':
                    status = iCurrent != target[attr];
                    break;
                case 'linear':
                    status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
                    break;
                case 'ease-in':
                    status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
                    break;
                default:
                    status = iCurrent != target[attr];
            }

            if (status) {
                flag = false;
                //opacity 和 scrollTop 需要特殊处理
                if (attr === "opacity") {
                    element.style.filter = "alpha(opacity:" + (iCurrent + iSpeed) + ")";
                    element.style.opacity = (iCurrent + iSpeed) / 100;
                } else if (attr === 'scrollTop') {
                    element.scrollTop = iCurrent + iSpeed;
                } else {
                    element.style[attr] = iCurrent + iSpeed + 'px';
                }
            } else {
                flag = true;
            }

            if (flag) {
                clearInterval(element.timer);
                if (callback) {
                    callback();
                }
            }
        })
    }, 20);
}


/**
 * 设置微信网页中标题
 */
export const setWechatTitle = (title) => {
    document.title = title
    var mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe')
        iframe.style.visibility = 'hidden'
        // 替换成站标favicon路径或者任意存在的较小的图片即可
        iframe.setAttribute('src', '../../favicon.ico')
        var iframeCallback = function() {
            setTimeout(function() {
                iframe.removeEventListener('load', iframeCallback)
                document.body.removeChild(iframe)
            }, 0)
        }
        iframe.addEventListener('load', iframeCallback)
        document.body.appendChild(iframe)
    }
}

/**
 * 设置微信网页中标题
 */
export const codeDispose =(options) => {

    // xlog code过滤 排查code 和 xlog接口错误记录
    var is_suc = options.excludeLogCode.findIndex(function (item) {
        return item == options.responseJson.data.code
    })
    // 过滤code值已6开头长度为7位的code值，不记xlog
    if (options.responseJson.data.code.toString().length == 7 && options.responseJson.data.code.toString().substring(0,1) == '6' && !options.shutLog) {
        options.shutLog = true;
    }
    if (is_suc == -1 && !options.shutLog) {
        var logContent = {
            code:"AJAX_CODE",
            ajaxUrl: options.ajaxUrl,
            log_type: "AJAX_CODE",
            request_data: options.request_data,
            request_cookie: document.cookie,
            response_data: {
                code: options.responseJson.data.code,
                msg: options.responseJson.data.msg
            },
        }
        errorLog('ERR',logContent);
    }
    // 用户未登陆过滤，跳转登录
    var is_login = options.logicCode.findIndex(function (item) {
        return item == options.responseJson.data.code
    })
    if (is_login != -1 && is_login != 6) {
        // 未登录跳转登录
        userLogin();
    } else if (is_login == 6) {
        // 未加入计划跳转到发现页
        if (isYzgx) { // 跳元知国学首页
            location.href = gxHostUrl + "/classroom_yz/yzgxStudy";
        } else {
            location.href = hostUrl + "/classroom_yz/study";
        }
    } else {
        options.callback && options.callback()
    }
}

/**
 * 错误日志
 */
export const errorLog = (level, content) => {
    try {
        var postData = content != null ? content : {};
        var timestamp = new Date().getTime();
        var user_id = getCookie("HTTP_X_YS_UID") ? getCookie("HTTP_X_YS_UID") : '';
        // 判断是否 ajaxUrl 上报日志
        if (postData.ajaxUrl) {
            postData.ajax_url_path = postData.ajaxUrl.split("?")[0]
        }
        //请求url
        postData.request_url = window.location.href ? window.location.href : '';
        // 请求url路径
        if (window.location.href.split('?').length > 2) {
            postData.request_url_path = window.location.href.split('?')[0] + window.location.href.split('?')[1];
        } else {
            postData.request_url_path = window.location.href.split('?')[0];
        }
        //AJAX_CODE 请求从response_data.msg中获取。非 AJAX_CODE 请求参数携带
        if (!postData.message) {
            postData.message = postData.response_data.msg
        }
        //PHPSESSID
        postData.phpsessID = getCookie("PHPSESSID") ? getCookie("PHPSESSID") : '';
        //用户token
        postData.usertoken = getCookie("HTTP_X_YS_USER_TOKEN") ? getCookie("HTTP_X_YS_USER_TOKEN") : '';
        //版本号
        var wechatInfo;
        if (isWeiXin()) {
            wechatInfo = navigator.userAgent.split("MicroMessenger")[1].split("/")[1].split(" ")[0] ? navigator.userAgent.split("MicroMessenger")[1].split("/")[1].split(" ")[0] : '';
        } else {
            wechatInfo = getCookie("HTTP_X_YS_SOFT");
        }
        //数据参数
        //level取值：DEBUG,INFO,WARN,ERR,FATAL
        //type取值WEB - H5 WP - 小程序 IOS - iOS-App AND - Android-App
        var messages = [{
            level: level,
            timestamp: timestamp,
            data: postData
        }];
        //存储log日志
        setErrorLog(pro_name, user_id, "wechat_" + wechatInfo, versions(), JSON.stringify(messages)).then(res => {

        })
    } catch (err) {
        var logContent = {
            code: "ERR",
            responseData: {
                msg: err.message,
            },
        }
        //存储log日志
        setErrorLog(pro_name, '', "wechat", '', JSON.stringify(logContent)).then(res => {

        })
    }
}


/**
 * 是否为移动终端、ios终端、android终端
 */
export const versions = (content) => {
    var u = navigator.userAgent,
        os;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
        os = "ios";
    } else if (isAndroid) {
        os = "android";
    } else {
        os = "";
    }
    return os;
}


/**
 * 数据base64加密
 */
export const Base64 = (str) => {
    var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
        52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 　0, 　1, 　2, 　3, 4, 　5, 　6, 　7, 　8, 　9, 10, 11, 12, 13, 14,
        15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
    var out, i, len;
    var c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt((c1 & 0x3) << 4);
            out += "==";
            break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            out += base64EncodeChars.charAt((c2 & 0xF) << 2);
            out += "=";
            break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3F);
    }
    return out;
}


/**
 * 随机数
 * @param  num min 范围区间最小值
 * @param  num max 范围区间最大值
 */
export const getRandomNum = (min, max) => {
    var Range = max - min;
    var Rand = Math.random();
    return min + Math.round(Rand * Range);
}

/**
 * 获取日期（月.日）
 * @param  string value 传入时间
 */
export const getDateTime = (value) => {
    if (value) {
        var date = new Date(value.replace(/-/g, '/'));
        var month = date.getMonth() + 1;
        var date = this.paddNum(date.getDate());
        return month + "." + date;
    }
}


/*
 * 将秒数格式化时间
 * @param {Number} seconds: 整数类型的秒数
 * @return {String} time: 格式化之后的时间
 */
export const formatTime = (seconds) => {
    var min = Math.floor(seconds / 60),
        second = Math.floor(seconds % 60),
        hour, newMin, time;

    if (min > 60) {
        hour = Math.floor(min / 60);
        newMin = min % 60;
    }

    if (second < 10) { second = '0' + second; }
    if (min < 10) { min = '0' + min; }

    return time = hour ? (hour + ':' + newMin + ':' + second) : (min + ':' + second);
}

/**
 * 获取日期（年-月-日）
 * @param  string value 传入时间
 */
export const formatDate = (value) => {
    if (value) {
        var date = new Date(value.replace(/-/g, '/'));
        var year = date.getFullYear();
        var month = paddNum(date.getMonth() + 1);
        var date = paddNum(date.getDate());
        return year + "-" + month + "-" + date;
    }
}

/**
 * 获取日期（*年*月*日）
 * @param  string value 传入时间
 */
export const formatDateN = (value) => {
    var date;
    if (value) {
        date = new Date(value.replace(/-/g, '/'));
    } else {
        date = new Date();
    }
    var year = date.getFullYear();
    var month = paddNum(date.getMonth() + 1);
    var date = paddNum(date.getDate());
    return year + "年" + month + "月" + date + "日";
}

/**
 * 获取日期（*年*月*日）
 * @param  string value 传入时间
 */
export const formatDateAll = (value, str) => {
    var date;
    if (value) {
        date = new Date(value.replace(/-/g, '/'));
    } else {
        date = new Date();
    }
    var year = date.getFullYear();
    var month = paddNum(date.getMonth() + 1);
    var date = paddNum(date.getDate());
    return year + str + month + str + date;
}

/**
 * 日期添加0
 * @param  string num 传入数值
 */
export const paddNum = (num) => {
    num += "";
    return num.replace(/^(\d)$/, "0$1");
}


/**
 * 是否为微信终端
 * @param
 */
export const isWeiXin = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    // console.log('isWeiXin ua', ua)
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

/**
 * 是否为有书APP
 */
export const isYSApp = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/youshugongdu/i) == 'youshugongdu' || (ua.match(/youshugongdu/i) == 'youshuapp') || (getCookie('HTTP_X_YS_OS') == 'ios' || getCookie('HTTP_X_YS_OS') == 'android')) {
        return true;
    } else {
        return false;
    }
}

const getUtmData = () => {
    var utmdata = new Object();
    if (getCookie('utm_source')) {
        utmdata.utm_source = getCookie('utm_source')
    }
    if (getCookie('utm_medium')) {
        utmdata.utm_medium = getCookie('utm_medium')
    }
    if (getCookie('utm_campaign')) {
        utmdata.utm_campaign = getCookie('utm_campaign')
    }
    if (getCookie('utm_term')) {
        utmdata.utm_term = getCookie('utm_term')
    }
    if (getCookie('utm_content')) {
        utmdata.utm_content = getCookie('utm_content')
    }
    return utmdata
}

/**
 * 获取cookie中的utm串
 */
export const getAllUtmStr = () => {
    var utm_string = '';
    if (getCookie('utm_source')) {
        utm_string += '&utm_source=' + getCookie('utm_source') || ''
    }
    if (getCookie('utm_medium')) {
        utm_string += '&utm_medium=' + getCookie('utm_medium') || ''
    }
    if (getCookie('utm_campaign')) {
        utm_string += '&utm_campaign=' + getCookie('utm_campaign') || ''
    }
    if (getCookie('utm_term')) {
        utm_string += '&utm_term=' + getCookie('utm_term') || ''
    }
    if (getCookie('utm_content')) {
        utm_string += '&utm_content=' + getCookie('utm_content') || ''
    }
    if (utm_string) utm_string = utm_string.substring(1)
    return utm_string
}

/**
 * 返回页面控制跳转
 * @param
 */
export const backJump = (options) => {
    console.log(options.jump_url)
    if (!window.history.pushState || !document.dispatchEvent) return;
    var href = location.href;
    var flag = true;
    var voidFn = function() {
        window.location.replace(options.jump_url)
    };
    var fn = voidFn;
    var dispatchFn = function() {
        var evt = document.createEvent('Event');
        evt.initEvent('popstate', true, true);
        window.dispatchEvent(evt);
    };

    history.pushState({}, '', href);

    window.addEventListener('popstate', function() {
        dispatchFn = voidFn;
        if (flag) {
            location.reload();
        }

        setTimeout(function() {
            fn = dispatchFn;
            fn();
        }, 20);
    }, false);
}

/**
 * 获取url传递数值
 * @param string name 参数名称
 */
export const getUrlKeyValue = (name) => {
    let text = "";
    const splitUrl = window.location.href
    if (splitUrl.startsWith('http:') || splitUrl.startsWith('https:')){
        let newUrl = new URL(splitUrl);
        let kvs = newUrl.searchParams.entries();
        for (let [k, v] of kvs) {
            if (k == name) {
                text = v;
                break;
            }
        }
    }else {
        if (splitUrl.split("?")[1]) {
            var url = splitUrl.split("?")[1].split("&");
            for (var i = 0; i < url.length; i++) {
                var id = splitUrl
                    .split("?")[1]
                    .split("&")
                [i].indexOf("=");
                var nick = splitUrl
                    .split("?")[1]
                    .split("&")
                [i].substring(0, id);
                if (name == nick) {
                    text = splitUrl
                        .split("?")[1]
                        .split("&")
                    [i].substring(id + 1);
                }
            }
        }
    }
    return text;
}

/**
 * 判断当前用户是否登录
 */
export const checkUserLogin = (page, url) => {
    if (getCookie('HTTP_X_YS_UID') != '' && getCookie('HTTP_X_YS_USER_TOKEN') != '' && getCookie('HTTP_X_YS_UID') > 0) {
        //初始化数据
        return true;
    } else {
        if (Tools.webEnv() == "weixin") {
            wxLogin(page, url)
        } else if (Tools.webEnv() == "app") {
            App.jumpToApp({
                v: soft,
                type: 37,
                data: {
                    url: url || location.href
                }
            })
        } else if (Tools.webEnv() == 'browser') {
            if (isYzgx) {
                location.href = gxHostUrl + '/classroom_yz/phoneLogin?callback_url=' + encodeURIComponent(window.location.href)
            } else {
                Login({
                    url: url || location.href,
                    wx_url: url || location.href,
                    app_url: url || location.href,
                })
            }
        }
        return false
    }
}

/**
 * 微信登录弹窗调用
 */
export const wxLogin = (page, url) => {
    Newlogin({
        showBtn: true,
        callback_url: url || location.href,
        appid: appid,
        loginType: 'weixin',
        onAgree: () => {
            console.log('登录弹窗同意')
        },
        onCancel: () => {
            if (page && (page == 'myself' || page == 'vip' || page == 'yzgxVip' || page == 'yzgxMall')) {
                window.location.replace(location.href)
            } else {
                if (url) {
                    window.location.replace(url)
                } else {
                    window.location.replace((isYzgx ? gxHostUrl : hostUrl) + '/classroom_yz' + (isYzgx ? '/yzgxStudy' : '/study'))
                }
            }
        }
    })
}

/**
 * 签名sign算法说明：
 * 1.GET,POST合并后的非空参数按key名字升序进行排序(ksort)后生按 k=v&k=v格式拼成字符串参数：buff
 * 2.请求时间戳参数：utt
 * 3.签名密钥key参数为cookie里的user_token，不存在则为空: key
 * 4.算法： sign = md5(md5(buff).md5(utt).key)
 * 获取url传递数值
 * @param utt  请求时间戳
 * @param sign 加密算法
 */
export const checkSign = (data, url, type) => {
    //参数定义
    let buff,
        utt = Date.parse(new Date()) / 1000,
        key = getCookie('HTTP_X_YS_USER_TOKEN') ? getCookie('HTTP_X_YS_USER_TOKEN') : '';
    //
    let postData = data != null ? checkOutParmes(data) : {};
    let postDataGroup = new Array();
    postData.timestamp = utt;
    postData.ys_app_name = pro_name;
    for (let i in objKeySort(postData)) {
        postDataGroup.push(i + "=" + postData[i])
    }
    buff = postDataGroup.join("&");
    let md5str = 'url=' + url + '|buff=' + buff + '|key=' + key
    // if (url.indexOf('m/xlog') == -1) {console.log('checkSign md5str', md5str)}
    postData.signature = md5(url + buff + key);
    if (type == 'GET') {
        let dataStr = ''; //数据拼接字符串
        Object.keys(postData).forEach(key => {
            dataStr += key + '=' + data[key] + '&';
        })
        if (dataStr !== '') {
            dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
            url = url + '?' + dataStr;
        }
    } else {
        url = url + '?timestamp=' + postData.timestamp + '&signature=' +  postData.signature + '&ys_app_name=' + postData.ys_app_name
    }
    return {
        url,
        md5str 
    }
}

// 过滤签名函数
export const checkOutParmes = (data) => {
    Object.keys(data).forEach(key => {
       if (key == 'timestamp' || key == 'signature' || key == 'ys_app_name') {
           delete data[key]
       }
    })
    return data;
}

//排序的函数
export const objKeySort = (obj) => {
    const newkey = Object.keys(obj).sort();
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    //创建一个新的对象，用于存放排好序的键值对
    const newObj = {};
    for (var i = 0; i < newkey.length; i++) {
        //排查为空字段
        if (obj[newkey[i]] !== '' && typeof(obj[newkey[i]]) != "undefined") {
            //遍历newkey数组，向新创建的对象中按照排好的顺序依次增加键值对
            newObj[newkey[i]] = obj[newkey[i]];
        }
    }
    return newObj; //返回排好序的新对象
}


/**
 * utm 设置
 * 获取url传递utm数据，存储到cookie中
 * 规则:1、最高优先级为url,如果url有 utm_source | utm_medium | utm_campaign | utm_term 获取url上utm数据
 * 2、url中没有对应的utm参数，从cookie中获取
 * 3、1).utm_source: url 或者 cookie 存在，保持不变，不存在默认设置为平台名称（微课为classroom_h5）
 *    2).utm_medium: url 或者 cookie 存在，保持不变，没有不做添加
 *    3).utm_campaign：直接保留 url 或者 cookie 中值，没有不做添加
 *    4).utm_term : 直接保留 url 或者 cookie 中值，没有不做添加
 *
 * @param string name 参数名称
 */
export const initUTMData = (object, routerPath) => {
    let utm_source, utm_medium, utm_campaign, utm_term, utm_content;

    //url UTM数据
    let urlUtmData = object;

    // cookie utm数据
    let cookieUtmData = {
        utm_source: getCookie('utm_source'),
        utm_medium: getCookie('utm_medium'),
        utm_campaign: getCookie('utm_campaign'),
        utm_term: getCookie('utm_term'),
    }
    console.log('urlUtmData', urlUtmData, 'cookieUtmData', cookieUtmData)

    // utm_source 数据初始化
    if (urlUtmData && urlUtmData.utm_source) {
        utm_source = urlUtmData.utm_source;
    } else if (cookieUtmData.utm_source != '') {
        utm_source = cookieUtmData.utm_source;
    } else if (cookieUtmData.utm_source == '' && !urlUtmData.utm_source) {
        utm_source = 'yuanzhi_h5';
    }

    // utm_medium 数据初始化
    if (urlUtmData && urlUtmData.utm_medium) {
        utm_medium = urlUtmData.utm_medium;
    } else if (cookieUtmData.utm_medium != '') {
        utm_medium = cookieUtmData.utm_medium;
    }

    //utm_campaign 保留原有，不做更改
    if (urlUtmData && urlUtmData.utm_campaign) {
        utm_campaign = urlUtmData.utm_campaign;
    } else if (cookieUtmData.utm_campaign != '') {
        utm_campaign = cookieUtmData.utm_campaign;
    }

    //utm_term 保留原有，不做更改
    if (urlUtmData && urlUtmData.utm_term) {
        utm_term = urlUtmData.utm_term;
    } else if (cookieUtmData.utm_term != '') {
        utm_term = cookieUtmData.utm_term;
    }

    // utm_content 保留原有，不做更改
    if (urlUtmData && urlUtmData.utm_content) {
        utm_content = urlUtmData.utm_content;
    }

    // 保存utm 至cookie
    let domain = "." + document.location.hostname.split('.')[1] + '.' + document.location.hostname.split('.')[2];
    let path = '/';

    // 保存utm_source 至cookie
    if (utm_source) {
        //如果url链接上有utm_source  或者  url和cookie中都没有值，设置为平台名称存储
        setCookie('utm_source', utm_source, '', domain, path);
    }

    // 保存utm_medium 至cookie
    if (utm_medium) {
        setCookie('utm_medium', utm_medium, '', domain, path);
    }

    // utm_campaign 至cookie
    if (utm_campaign) {
        setCookie('utm_campaign', utm_campaign, '', domain, path);
    }

    // utm_term 至cookie
    if (utm_term) {
        setCookie('utm_term', utm_term, '', domain, path);
    }

    // utm_content 至cookie
    if (utm_content) {
        setCookie('utm_content', utm_content, '', domain, path);
    }
}

/**
 * utm_content 设置
 * 获取cookie中utm_content值，然后拼接存储
 * @param type:
 * firstpage 第一个触达页面
 * mainpage 产品主页面的最后一个tab, 如果没有tab，则为主页面，如果没有到达主页面，则为空
 * mainaction 落地页最近一次订单交互
 * lastpage 下单前页面
 * @param string name 参数名称
 */
export const editUTMcontent = (type, object) => {
    let utm_content, utm_medium, product, firstpage, mainpage, mainaction, lastpage, grouppage, havemedium;
    // 保存utm 至cookie
    let domain = "." + document.location.hostname.split('.')[1] + '.' + document.location.hostname.split('.')[2];
    let path = '/';

    grouppage = ['study', 'vip', 'myself', 'yzgxStudy', 'yzgxVip', 'yzgxMall'];
    //获取当前utm_content值
    utm_content = getCookie('utm_content');
    //获取当前utm_medium值
    utm_medium = getCookie('utm_medium');
    //获取havemedium
    havemedium = getCookie('havemedium');

    //utm_content 参数配置
    //产品标识
    product = utm_content.split('|')[0] ? utm_content.split('|')[0] : '';
    //第一个触达页面
    firstpage = utm_content.split('|')[1] ? utm_content.split('|')[1] : '';
    //最后落地页面
    mainpage = utm_content.split('|')[2] ? utm_content.split('|')[2] : '';
    //落地页最近一次订单交互
    mainaction = utm_content.split('|')[3] ? utm_content.split('|')[3] : '';
    //下单前页面
    lastpage = utm_content.split('|')[4] ? utm_content.split('|')[4] : '';

    //参数类型
    if (type == 'mainpage') {
        let haveRouter = false,
            ismainpage = false;
        //修改首次落地页参数
        for (let i in grouppage) {
            if (mainpage.indexOf(grouppage[i] + '_') > -1) {
                haveRouter = true;
            }
            if (grouppage[i] == object.routerPath) {
                ismainpage = true;
            }
        }

        if (haveRouter) {
            for (let i in grouppage) {
                if (mainpage.indexOf(grouppage[i] + '_') > -1) {
                    //如果 utm_content 存在此路由，替换原路由参数
                    mainpage = mainpage.split(grouppage[i] + '_')[0] + object.routerPath + (object.tabbar != '' ? '_' + object.tabbar : '');
                }
            }
        } else if (ismainpage) {
            //记录最后落地主页面
            mainpage = 'T:' + object.routerPath + (object.tabbar != '' ? '_' + object.tabbar : '');
        } else {
            //不是主页面默认为空
            mainpage = 'T:';
        }
        //跳转到主要入口页面时，重置参数
        // mainaction = '';
        // lastpage = '';
    } else if (type == 'mainaction') {

        //落地页最近一次订单交互
        mainaction = 'A:' + object.mainaction;
    } else if (type == 'lastpage') {

        //下单前页面
        lastpage = 'B:' + object.lastpage;
    }

    utm_content = product + '|' + firstpage + '|' + mainpage + '|' + mainaction + '|' + lastpage;

    //判断跳转平台前是否有utm_medium数据，如果有保持不变，如果没有更新
    if (!parseInt(havemedium)) {
        utm_medium = firstpage + '|' + mainpage + '|' + mainaction + '|' + lastpage;
        //更新 utm_content 至cookie
        setCookie('utm_medium', utm_medium, '', domain, path);
    }

    //更新 utm_content 至cookie
    setCookie('utm_content', utm_content, '', domain, path);

}

/**
 * 从获取当前环境utm数据
 */
export const getUTMcourse = () => {
    let utm_source, utm_medium, utm_campaign, utm_term, utm_content, returnValue;
    utm_source = getCookie('utm_source');
    utm_medium = getCookie('utm_medium');
    utm_campaign = getCookie('utm_campaign');
    utm_content = getCookie('utm_content');
    utm_term = getCookie('utm_term');
    //utm_campaign 保留原有，不做更改
    if (utm_source) {
        returnValue = 'utm_source=' + utm_source;
    }
    if (utm_medium) {
        returnValue = returnValue + (returnValue ? '&' : '') + 'utm_medium=' + utm_medium;
    }
    if (utm_campaign) {
        returnValue = returnValue + (returnValue ? '&' : '') + 'utm_campaign=' + utm_campaign;
    }
    if (utm_term) {
        returnValue = returnValue + (returnValue ? '&' : '') + 'utm_term=' + utm_term;
    }
    return returnValue;
}

/**
 * 截取配置参数（分享卡片、分享标题）
 */
export const InterceptContentData = (content, object) => {
    if (!content) {
        return
    }
    // studyDay:学习第几天,studyTitle:学习进度,bookTitle:当前学习书籍名称,countDownTime:倒计时时间,joinDays:加入有书的时间,totalCheckNum:累计签到次数,keepCheckNum:连续签到次数,readBookCount:阅读书的数量,
    let share_content = content;
    let studyDay = object.studyDay;
    let studyTitle = object.studyTitle;
    let bookTitle = object.bookTitle;
    let countDownTime = object.countDownTime;
    let joinDays = object.joinDays;
    let totalCheckNum = object.totalCheckNum;
    let keepCheckNum = object.keepCheckNum;
    let readBookCount = object.readBookCount;
    // 截取对应的值，替换
    if (share_content && share_content.split("studyDay").length == 2) {
        share_content = share_content.split("studyDay")[0] + studyDay + share_content.split("studyDay")[1];
    }
    if (share_content && share_content.split("studyTitle").length == 2) {
        share_content = share_content.split("studyTitle")[0] + studyTitle + share_content.split("studyTitle")[1];
    }
    if (share_content && share_content.split("bookTitle").length == 2) {
        share_content = share_content.split("bookTitle")[0] + bookTitle + share_content.split("bookTitle")[1];
    }
    if (share_content && share_content.split("countDownTime").length == 2) {
        share_content = share_content.split("countDownTime")[0] + countDownTime + share_content.split("countDownTime")[1];
    }
    if (share_content && share_content.split("joinDays").length == 2) {
        share_content = share_content.split("joinDays")[0] + joinDays + share_content.split("joinDays")[1];
    }
    if (share_content && share_content.split("totalCheckNum").length == 2) {
        share_content = share_content.split("totalCheckNum")[0] + totalCheckNum + share_content.split("totalCheckNum")[1];
    }
    if (share_content && share_content.split("keepCheckNum").length == 2) {
        share_content = share_content.split("keepCheckNum")[0] + keepCheckNum + share_content.split("keepCheckNum")[1];
    }
    if (share_content && share_content.split("readBookCount").length == 2) {
        share_content = share_content.split("readBookCount")[0] + readBookCount + share_content.split("readBookCount")[1];
    }
    return share_content;
}
/**
 * 版本号比较
 * @param [string] curV 当前版本号
 * @param [string] reqV 比较版本号
 * 1：新版本，0：稳定版，-1：旧版本
 */
export const verCom = (curV, reqV) => {
    let arr1 = curV ? curV.split('.') : '0.0.0',
        arr2 = reqV ? reqV.split('.') : '0.0.0',
        minL = Math.min(arr1.length, arr2.length),
        pos = 0,
        diff = 0;

    while (pos < minL) {
        diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
        if (diff != 0) {
            break;
        }
        pos++
    }
    if (diff > 0) {
        return 1
    } else if (diff == 0) {
        return 0
    } else {
        return -1
    }
}

/**
 * 调起登陆弹窗
 */
export const userLogin = () => {
    if (Tools.webEnv() == "weixin") {
        wxLogin()
    } else if (Tools.webEnv() == "app") {
        App.jumpToApp({
            v: soft,
            type: 37,
            data: {
                url: authorizationUrl +'/p/readBook/readbook_app'
            }
        })
    } else if (Tools.webEnv() == 'browser') {
        if (isYzgx) {
            location.href = gxHostUrl + '/classroom_yz/phoneLogin?callback_url=' + encodeURIComponent(window.location.href)
        } else {
            Login({
                url: location.href,
                wx_url: location.href,
                app_url: location.href,
            })
        }
    }
}

/**
 * 微信重授权接口
 */
export const wxLoginAjax = (path, query) => {
    let cust_auth = 1
    if(query.cust_auth>=0){
        cust_auth = query.cust_auth
    }
    wxAuth({
        appid,
        code: getUrlKeyValue('code') || query.code || '',
        auth_type: 1,
        is_register: cust_auth
    }).then(res => {
        if (query.code) delete query.code
        if (query.loginType) delete query.loginType
        if (res.code == 1) { // 登录成功
            console.log('aaaa', res.data)
            setCookie('HTTP_X_YS_UID', res.data.user_id)
            setCookie('HTTP_X_YS_USER_TOKEN', res.data.user_token)
            Toast('登录成功')
            if (query.code) delete query.code
            if (query.loginType) delete query.loginType
            let dataStr = ''; //数据拼接字符串
            Object.keys(query).forEach(key => {
                dataStr += key + '=' + query[key] + '&';
            })
            let url = window.location.origin + window.location.pathname + '?' + dataStr.substr(0, dataStr.lastIndexOf('&'));
            window.location.replace(url)
        } else { // 登录失败提示用户
            Toast(res.code + '-登录失败请刷新重试')
            let timer = setTimeout(() => {
                clearTimeout(timer)
                let dataStr = ''; //数据拼接字符串
                Object.keys(query).forEach(key => {
                    dataStr += key + '=' + query[key] + '&';
                })
                let url = window.location.origin + window.location.pathname + '?' + dataStr.substr(0, dataStr.lastIndexOf('&'));
                window.location.replace(url)
            }, 1500)
        }
    })
}

/**
 * formats格式包括
 * 1. Y-m-d
 * 2. Y-m-d H:i:s
 * 3. Y年m月d日
 * 4. Y年m月d日 H时i分
 **/
export const dateFormat = (timestamp, formats) => {
    formats = formats || 'Y-m-d';
    let zero = function (value) {
        if (value < 10) {
            return '0' + value;
        }
        return value;
    };
    let myDate = timestamp ? new Date(timestamp) : new Date();
    let year = myDate.getFullYear();
    let month = zero(myDate.getMonth() + 1);
    let day = zero(myDate.getDate());
    let hour = zero(myDate.getHours());
    let minite = zero(myDate.getMinutes());
    let second = zero(myDate.getSeconds());

    return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
        return ({
            Y: year,
            m: month,
            d: day,
            H: hour,
            i: minite,
            s: second
        })[matches];
    });
}
/**
 * scheme类型截取
 * @param  scheme 字符串
 * type  截取类型
 *  h5 跳转外部H5链接 
 */
export const getCardSchemeValue = (scheme, that) => {
  let type = '';
  if (scheme.split('yzgx:').length > 1) {
    type = scheme.split('?')[0].split('yzgx://')[1];
    if (type == 'h5') {
        window.location.href = decodeURIComponent(scheme.split('url=')[1]);
    } else if (type == 'yzgxStudy') { // 学习tab页
        that.$router.push({ path: '/yzgxStudy', query: {position: scheme.split('position=')[1]?.split('&')[0]} });
    }else if (type == 'yzgxMall') { // 商城tab页
        if (npm_env == 'luoluo' || npm_env == 'prod') {
            window.location.href = 'https://shop134475091.youzan.com/v2/showcase/homepage?alias=N8O6BBNLAg&dc_ps=3373258759718589443.300001'
        } else {
            window.location.href = 'https://shop127817349.youzan.com/v2/showcase/homepage?alias=oMsQL3BYzO&dc_ps=3369623134209594376.300001'
        }
    }else if (type == 'yzgxVip') { // 商城tab页
        that.$router.push({path: '/yzgxVip'});
    }else if (type == 'myself') { // 商城tab页
        that.$router.push({path: '/myself'});
    }else if (type == 'yzgxExperience') { // 商城tab页
        that.$router.push({path: '/yzgxExperience'});
    }else if(type == 'studySys') {
        that.$router.push({
          path: isYzgx ? '/studyCenter' : '/studySys',
          query: {
            plan_id: scheme.split('plan_id=')[1]?.split('&')[0],
            pb_id: scheme.split('pb_id=')[1]?.split('&')[0]
          }
        })
    }else if(type == 'packInfo') {
      that.$router.push({
        path: '/packInfo',
        query: {
          plan_id: scheme.split('plan_id=')[1]?.split('&')[0],
          pb_id: scheme.split('pb_id=')[1]?.split('&')[0],
          pack_id: scheme.split('pack_id=')[1]?.split('&')[0]
        }
      })
    }
  } else {
    window.location.href = decodeURIComponent(scheme);
  }
}

/**
 * 获取url传递数值
 * @param string key 参数名称
 */
export const getIdVal = (scheme, key) => {
    let text = "";
    if (scheme.startsWith('http:') || scheme.startsWith('https:')){
        let newUrl = new URL(scheme);
        let kvs = newUrl.searchParams.entries();
        for (let [k, v] of kvs) {
            if (k == name) {
                text = v;
                break;
            }
        }
    }else {
        console.log('getIdVal', scheme, key)
        if (scheme.split("?")[1]) {
            var url = scheme.split("?")[1].split("&");
            for (var i = 0; i < url.length; i++) {
                var id = scheme
                    .split("?")[1]
                    .split("&")
                [i].indexOf("=");
                var nick = scheme
                    .split("?")[1]
                    .split("&")
                [i].substring(0, id);
                if (name == nick) {
                    text = scheme
                        .split("?")[1]
                        .split("&")
                    [i].substring(id + 1);
                }
            }
        }
    }
    // console.log('getIdVal text', text)
    return text;
}

// 获取string中需要的key值的value
export const getUrlParam = (sUrl, sKey) => {
    var resObj = {};
    var reg = /(\w+)=(\w+)/g;
    while (reg.exec(sUrl)) {
        resObj[RegExp.$1] ? resObj[RegExp.$1] = [].concat(resObj[RegExp.$1], RegExp.$2) : resObj[RegExp.$1] = RegExp.$2;
    }
    if (sKey) {
        return (resObj[sKey] ? resObj[sKey] : '');
    }
    return resObj;
}
